import './toast.css';
import iZtoast from 'izitoast';
import Language from '../Language/Language.js';


const toast = {

  error: (message, title) => {
    message = message == undefined ? Language.GetLanguageByID(3635.01) : message;
    return iZtoast.error({
      theme: 'qradar-toast',
      icon: 'icon-ban',
      title: title,
      titleColor: '#f44336',
      backgroundColor: '#fff',
      borderColor: '',
      message: message,
      iconColor: '#f44336',
      timeout: 5000, 
      position: 'bottomRight',
      distanceY: 20, // Integer value
      distanceX: 20, // Integer value
      rtl: false,
      animateInside: true,
      drag: true,
      pauseOnHover: true,
      resetOnHover: false,
      progressBar: true,
      progressBarColor: '#f44336',
      progressBarEasing: 'linear',
      overlay: false,
      overlayClose: false,
      layout: 2,
      displayMode: 2,
      titleSize: 15,
      messageSize: 15,

      onOpening: function (instance, toast) {
        console.info('callback abriu!');
      },
      onClosing: function (instance, toast, closedBy) {
        console.info('closedBy: ' + closedBy); // tells if it was closed by 'drag' or 'button'
      }

    });
  },
  success: (message, title = 'Success') => {
    return iZtoast.success({
      theme: 'qradar-toast',
      icon: 'icon-check',
      title: title,
      titleColor: ' #35e591',
      backgroundColor: '#fff',
      borderColor: '',
      message: message,
      iconColor: ' #35e591',
      timeout: 5000,
      position: 'bottomRight',
      distanceY: 20, // Integer value
      distanceX: 20, // Integer value
      rtl: false,
      animateInside: true,
      drag: true,
      pauseOnHover: true,
      resetOnHover: false,
      progressBar: true,
      progressBarColor: ' #35e591',
      progressBarEasing: 'linear',
      overlay: false,
      overlayClose: false,
      layout: 2,
      displayMode: 2,
      titleSize: 15,
      messageSize: 15,

      onOpening: function (instance, toast) {
        console.info('callback abriu!');
      },
      onClosing: function (instance, toast, closedBy) {
        console.info('closedBy: ' + closedBy); // tells if it was closed by 'drag' or 'button'
      }
    });
  },
  warning: (message, title) => {
    message = message == undefined ? Language.GetLanguageByID(3635.01) : message;
    return iZtoast.error({
      theme: 'qradar-toast',
      icon: 'fa fa-warning',
      title: title,
      titleColor: '#f44336',
      backgroundColor: '#fff',
      borderColor: '',
      message: message,
      iconColor: '#f44336',
      timeout: 5000,
      position: 'bottomRight',
      distanceY: 20, // Integer value
      distanceX: 20, // Integer value
      rtl: false,
      animateInside: true,
      drag: true,
      pauseOnHover: true,
      resetOnHover: false,
      progressBar: true,
      progressBarColor: '#f44336',
      progressBarEasing: 'linear',
      overlay: false,
      overlayClose: false,
      layout: 2,
      displayMode: 2,
      titleSize: 15,
      messageSize: 15,

      onOpening: function (instance, toast) {
        console.info('callback abriu!');
      },
      onClosing: function (instance, toast, closedBy) {
        console.info('closedBy: ' + closedBy); // tells if it was closed by 'drag' or 'button'
      }

    });
  }
};

export default toast;
